import React, { useState } from 'react'
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Collapse
} from 'reactstrap'
import PropTypes from 'prop-types'

const ISSUE_COLORS = {
  duplicate: 'warning',
  conflict: 'danger',
  missingLocale: 'info'
}

const ISSUE_ICONS = {
  duplicate: '🔀',
  conflict: '⚠️',
  missingLocale: '🏷️'
}

const IssueCard = ({
  children,
  issueKey,
  issueType,
  locale = null,
  recordCount = 1,
  subtitle = null,
  title
}) => {
  const [isOpen, setIsOpen] = useState(true)

  const color = ISSUE_COLORS[issueType] || 'secondary'
  const icon = ISSUE_ICONS[issueType] || '❓'

  return (
    <Card className="mb-3 issue-card no-lift">
      <CardHeader
        className={`issue-card-header issue-card-header--${issueType} d-flex align-items-center justify-content-between`}
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        style={{ cursor: 'pointer' }}
      >
        <div className="d-flex align-items-center gap-2">
          <span className="fs-5">{icon}</span>
          <div>
            <span className="fw-semibold">{title}</span>
            <code className="ms-2 issue-key-badge px-2 py-1 rounded">{issueKey}</code>
            {locale && (
              <Badge color="info" className="ms-2">
                {locale}
              </Badge>
            )}
            {recordCount > 1 && (
              <Badge color="secondary" className="ms-2">
                {recordCount} occurrences
              </Badge>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          {subtitle && (
            <small className="text-muted">{subtitle}</small>
          )}
          <span className={`transform-rotate ${isOpen ? 'rotate-180' : ''}`}>
            ▼
          </span>
        </div>
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody>
          {children}
        </CardBody>
      </Collapse>
    </Card>
  )
}

IssueCard.propTypes = {
  children: PropTypes.node.isRequired,
  issueKey: PropTypes.string.isRequired,
  issueType: PropTypes.oneOf(['duplicate', 'conflict', 'missingLocale']).isRequired,
  locale: PropTypes.string,
  recordCount: PropTypes.number,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default IssueCard
